import React, { useEffect, useState, useLayoutEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Router, RouteComponentProps, Link } from "@reach/router";
// import { TreeMenuBlock } from '../tree-menu/TreeMenu';
import { MultiselectPositionsMenu } from '../positions-menu/MultiselectPositionsMenu';
import { SubMenu } from '../menu/subMenu';
import { PositionMap } from './map/PositionMap';
import { List } from './list/List';
import { Power } from './power/Power';
import { Alarms } from './alarms/Alarms';
import { DataExport } from './data-export/DataExport';
import { isEqual } from 'lodash';
import { isJsonEqual } from '../../lib/typeCheck';

import { initNodes, getSelectedNodes } from '../../store/positions/menuNodesSlice'

const LeftContainer = styled.div<RouteComponentProps>`
  display: none;
  margin-left: 0px;
  width: 20%;
  height: 100%;
  background: #FFF;
  border-right: 1px solid #AAA;
  overflow-y: scroll;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const MiddleContainer = styled.div<RouteComponentProps>`
  width: 100%;
  height: 100%;
  background: #FFF;
  position: relative;
`;

const RightContainer = styled.div`
  width: 20%;
  height: 100%;
  background: #FFF;
`;

const StyledRouter = styled(Router)`
  height: 100%;
  width: 100%;
`;

const StyledDevices = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;

type DevicesProps = RouteComponentProps & {
  features: any;
  children?: React.ReactNode;
}

export const Devices = (props: DevicesProps) => {

  const menuNodePositions = useSelector(getSelectedNodes, isJsonEqual);
  const dispatch = useDispatch();
  
  return (
    <StyledDevices>
      <LeftContainer path='*'>
        <MultiselectPositionsMenu path='*'/>
      </LeftContainer>
      <MiddleContainer path='*'>
        {props.features.sub.menu? <SubMenu features={props.features}/> : null}

        <StyledRouter>
          <PositionMap features={props.features} fullscreen={false} path='/'/>
          <List path='/list'/>
          <Power path='/power'/>
          <Alarms path='/alarms'/>
          <DataExport path='/export'/>
        </StyledRouter>

      </MiddleContainer>
    </StyledDevices>
  )
}
